import { Cartesian3, HeadingPitchRange, Math as CesiumMath, BoundingSphere, Cartographic, Cartesian2, } from "cesium";
export class ViewerCamera {
    static _instance;
    _viewer;
    constructor(viewer) {
        this._viewer = viewer;
    }
    static getInstance(viewer) {
        if (!ViewerCamera._instance) {
            ViewerCamera._instance = new ViewerCamera(viewer);
        }
        return ViewerCamera._instance;
    }
    get rawCamera() {
        return this._viewer.camera;
    }
    flyToLongLatHeight({ longitude, latitude, height, duration = 0, }) {
        this.rawCamera.flyTo({
            destination: Cartesian3.fromDegrees(longitude, latitude, height),
            duration: duration,
        });
    }
    zoomIn() {
        const currentHeight = this.rawCamera.positionCartographic.height;
        this.rawCamera.zoomIn(currentHeight / 4);
    }
    zoomOut() {
        const currentHeight = this.rawCamera.positionCartographic.height;
        this.rawCamera.zoomOut(currentHeight / 2);
    }
    getPickRay(mousePosition) {
        return this.rawCamera.getPickRay(mousePosition);
    }
    set2DView(topLeft, topRight, bottomRight, bottomLeft) {
        const cameraOffset = new HeadingPitchRange(CesiumMath.toRadians(0.0), CesiumMath.toRadians(-90.0), 0.0);
        const boundingSphere = BoundingSphere.fromPoints([
            topLeft,
            topRight,
            bottomRight,
            bottomLeft,
        ]);
        this.rawCamera.flyToBoundingSphere(boundingSphere, {
            offset: cameraOffset,
        });
        this.rawCamera.switchToOrthographicFrustum();
        this._viewer.scene.screenSpaceCameraController.enableTilt = false;
    }
    set3DView() {
        this.rawCamera.switchToPerspectiveFrustum();
        this._viewer.scene.screenSpaceCameraController.enableTilt = true;
    }
    set2DViewFromCurrentPosition() {
        // 1. Compute the screen‐space center of the canvas
        const canvas = this._viewer.scene.canvas;
        const centerPx = new Cartesian2(canvas.clientWidth / 2, canvas.clientHeight / 2);
        // 2. Cast a pick ray through the center and intersect with the globe
        const pickRay = this.rawCamera.getPickRay(centerPx);
        let centerCartesian = this._viewer.scene.globe.pick(pickRay, this._viewer.scene);
        // 3. Fallback: if the ray misses (e.g. looking at sky), use current camera position
        if (!centerCartesian) {
            centerCartesian = Cartographic.toCartesian(this.rawCamera.positionCartographic);
        }
        // 4. Convert the center point to cartographic (lon/lat/height)
        const centerCartographic = Cartographic.fromCartesian(centerCartesian);
        // 5. Preserve the current camera altitude
        const currentHeight = this.rawCamera.positionCartographic.height;
        // 6. Compute a destination directly above the center at the same height
        const destination = Cartesian3.fromRadians(centerCartographic.longitude, centerCartographic.latitude, currentHeight);
        // 7. Fly the camera to that point, heading north and pitched straight down
        this.rawCamera.flyTo({
            destination: destination,
            orientation: {
                heading: CesiumMath.toRadians(0.0), // face north
                pitch: -CesiumMath.PI / 2, // look straight down
                roll: 0.0,
            },
            // you can adjust duration if you want a slower/faster transition
            duration: 0.5,
        });
        // 8. Switch to orthographic projection for a true top‐down view
        this.rawCamera.switchToOrthographicFrustum();
        this._viewer.scene.screenSpaceCameraController.enableTilt = false;
    }
    setEnableRotate(enable) {
        this._viewer.scene.screenSpaceCameraController.enableRotate = enable;
    }
    showGlobalView() {
        this.rawCamera.flyHome();
    }
}
//# sourceMappingURL=viewer-camera.js.map